import { compose as e } from "../../tailwind-buddy-interface.js";
const o = e({
  slots: {
    root: "",
    control: `
      relative 
      shrink-0 
      w-300
      h-300
      rounded-xs
    `,
    input: `
      
      z-[1] 
      absolute 
      inset-x-0
      inset-y-0
      appearance-none 
      focus-visible:outline-none 

      peer 
    `,
    shape: `
      absolute 
      top-025
      start-025
      w-250
      h-250
      rounded-xs
      outline
    `,
    icon: `
      absolute 
      top-050
      start-050
      peer-[:not(:checked)]:scale-0
    `
  },
  variants: {
    /** Sets the variant of the checkbox. */
    variant: {
      outlined: {},
      solid: {}
    }
  },
  compoundVariants: [
    // disableAnimation="false"
    {
      conditions: { disableAnimation: !1 },
      class: {
        icon: `
          transition-transform
          duration-quick
          ease-out-expressive
        `
      }
    },
    // isDisabled="false"
    {
      conditions: { isDisabled: !1 },
      class: {
        input: "cursor-pointer",
        shape: `
          outline-width-md

          peer-focus-visible:ring
          
          peer-focus-visible:ring-offset-[calc(theme(outlineWidth.width-md))]
        `
      }
    },
    // isDisabled="true"
    {
      conditions: { isDisabled: !0 },
      class: {
        input: "cursor-not-allowed",
        shape: `
          bg-color-scheme-interactive-disabled-100
          outline-width-sm
          outline-color-scheme-interactive-disabled-200
        `,
        icon: "text-color-scheme-interactive-disabled-400"
      }
    },
    // isInvalid="false" / isDisabled="false"
    {
      conditions: {
        isInvalid: !1,
        isDisabled: !1
      },
      class: {
        shape: `
          bg-color-canvas-primary
          outline-color-primary

          peer-hover:peer-[:not(:checked)]:bg-color-canvas-secondary
          peer-hover:peer-[:not(:checked)]:outline-color-scheme-neutral-200
        `
      }
    },
    // isInvalid="true" / isDisabled="false"
    {
      conditions: {
        isInvalid: !0,
        isDisabled: !1
      },
      class: {
        shape: `
          bg-color-scheme-functional-negative-100
          outline-color-scheme-functional-negative-400
        `
      }
    },
    // variant="outlined" / isInvalid="false" / isDisabled="false"
    {
      conditions: {
        variant: "outlined",
        isInvalid: !1,
        isDisabled: !1
      },
      class: {
        shape: `
          peer-checked:bg-color-canvas-primary
          peer-checked:outline-color-primary
        `,
        icon: "text-color-scheme-neutral-800"
      }
    },
    // variant="solid" / isInvalid="false" / isDisabled="false"
    {
      conditions: {
        variant: "solid",
        isInvalid: !1,
        isDisabled: !1
      },
      class: {
        shape: `
          peer-checked:bg-color-scheme-interactive-selected-500
          peer-checked:outline-color-scheme-interactive-selected-600
        `,
        icon: "text-icon-color-primary-inverse"
      }
    },
    // variant="outlined" / isInvalid="true" / isDisabled="false"
    {
      conditions: {
        variant: "outlined",
        isInvalid: !0,
        isDisabled: !1
      },
      class: {
        shape: `
          peer-checked:bg-color-scheme-functional-negative-100
          peer-checked:outline-color-scheme-functional-negative-400
        `,
        icon: "text-color-scheme-functional-negative-600"
      }
    },
    // variant="solid" / isInvalid="true" / isDisabled="false"
    {
      conditions: {
        variant: "solid",
        isInvalid: !0,
        isDisabled: !1
      },
      class: {
        shape: `
          peer-checked:bg-color-scheme-functional-negative-500
          peer-checked:outline-color-scheme-functional-negative-600
        `,
        icon: "text-icon-color-primary-inverse"
      }
    }
  ],
  responsiveVariants: [],
  defaultVariants: {
    variant: "outlined"
  }
})();
export {
  o as checkboxVariants
};
